import React from 'react';
import AuthService from './authService.js';
import OpportunityItem from '../Domain/OpportunityItem';
import SearchParams from '../Elements/SearchParams';
import OpportunitySearchParams from '../Contents/Sales/OpportunityAdmin/OpportunitySearchParams';

class OpportunityService extends React.Component {
  static GetOpportunityList(
    opportunityId,
    clientIdFilter,
    projectIdFilter,
    opportunityIdFilter,
    surveyIdFilter,
    tpProjectIdFilter,
    tpSurveyIdFilter
  ) {
    const searchItem = {
      ClientId: clientIdFilter,
      ProjectId: projectIdFilter,
      OpportunityId: opportunityIdFilter,
      SurveyId: surveyIdFilter,
      TpProjectId: tpProjectIdFilter,
      TpSurveyId: tpSurveyIdFilter,
    };

    let url = '/api/Opportunity';

    if (opportunityId != null && opportunityId !== -1) {
      url += `/GetOpportunityById/${opportunityId}?clearCache=true`;
    } else {
      url += `?searchItem=${JSON.stringify(searchItem)}&clearCache=true`;
    }

    return AuthService.getInstance().CallBackendFunction(url);
  }

  static GetOpportunityByProjectId(projectId) {
    const authService = AuthService.getInstance();

    let url = '/api/Opportunity';

    if (projectId != null && projectId !== -1) {
      url += `?clientFeeId=${projectId}`;
    }
    url += `${url.includes('?') ? '&' : '?'}clearCache=false`;
    return authService.CallBackendFunction(url);
  }

  static GetOpportunityByClientId(clientId) {
    const authService = AuthService.getInstance();
    let url = '/api/Opportunity';
    if (clientId != null && clientId !== -1) url += `?clientId=${clientId}`;
    url += `${url.includes('?') ? '&' : '?'}clearCache=false`;

    return authService.CallBackendFunction(url);
  }

  static async GetOpportunityByClientIds(clientIds) {
    const authService = AuthService.getInstance();

    const url = '/api/Opportunity/GetOpportunitiesByClientIds';

    const data = JSON.stringify(clientIds);
    return authService.CallBackendFunctionPost(url, data);
  }

  static GetOpportunityNameById(id) {
    const authService = AuthService.getInstance();

    const url = `/api/Opportunity/GetOpportunityNameById/${id}?clearCache=false`;

    return authService.CallBackendFunction(url);
  }

  static GetAllOpportunitiesForNewProject(clientId, startDate, endDate) {
    const searchParams = {
      Command: '',
      OrderBy: '',
      OrderDirection: '',
      PageNumber: 0,
      NumberOfElementsOnAPage: 0,
      SearchItem: {
        ClientId: clientId,
        StartDate: new Date(startDate),
        EndDate: new Date(endDate),
      },
    };
    const url = `/api/Opportunity/GetAllOpportunitiesForNewProjectAsync?searchParams=${JSON.stringify(searchParams)}`;

    return AuthService.getInstance().CallBackendFunction(url);
  }

  static GetOpportunityItemList(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache = false) {
    const searchParams = new SearchParams(searchItem, OpportunitySearchParams, orderById, orderDir, pageNumber, numberOfElements);
    const url = `/api/Opportunity/GetAllOpportunityAsync?searchParams=${searchParams.serializeForBackendCall()}&clearCache=${clearCache}`;

    return AuthService.getInstance().CallBackendFunction(url);
  }

  static ConvertDBItem(items) {
    const convertedItems = [];

    if (items !== null) {
      items.forEach((item) => {
        const newItem = new OpportunityItem(item);
        convertedItems.push(newItem);
      });
    }
    return convertedItems;
  }

  static async GetOpportunityCurrencyCode(opportunityId) {
    const url = `/api/Opportunity/GetOpportunityCurrencyCodeAsync/${opportunityId}?clearCache=false`;
    return AuthService.getInstance().CallBackendFunction(url);
  }

  static GetOpportunityNavigation(id) {
    const url = `/api/Opportunity/GetOpportunityNavigation/${id}?clearCache=false`;

    return AuthService.getInstance().CallBackendFunction(url);
  }

  static PostEndDate(item) {
    item.ActualEndOn = item.ActualEndOnOverrid;
    const url = '/api/Opportunity/PostOpportunity/';
    const string = this.toString(item);
    const json = JSON.stringify(string);
    return AuthService.getInstance().CallBackendFunctionPost(url, json);
  }

  static PostOpportunity(item) {
    const url = '/api/Opportunity/PostOpportunity/';
    const string = this.toString(item);
    const json = JSON.stringify(string);
    return AuthService.getInstance().CallBackendFunctionPost(url, json);
  }

  static toString(o) {
    Object.keys(o).forEach((k) => {
      if (typeof o[k] === 'object') {
        return toString(o[k]);
      }
      o[k] = `${o[k]}`;
    });
    return o;
  }

  static ExportAdminExcelAsync(searchItem) {
    const url = `/api/Opportunity/ExportAdminExcelAsync?searchItem=${JSON.stringify(searchItem)}`;
    return AuthService.getInstance().CallBackendFunction(url);
  }
}

export default OpportunityService;
